// types
import { ReactNode } from 'react';

// mui
import {
	Box,
	Checkbox as MuiCheckbox,
	CheckboxProps as MuiCheckboxProps,
	Grid,
	InputLabel,
	SxProps,
	Typography,
} from '@mui/material';

// props
export interface CheckboxProps extends MuiCheckboxProps {
	helperText?: ReactNode;
	label?: string;
	sxBox?: SxProps;
}
export const Checkbox = ({
	disabled,
	helperText,
	id,
	label,
	required,
	sxBox = {},
	...props
}: CheckboxProps) => {
	return (
		<Box
			sx={(theme) => {
				return {
					borderColor: theme.palette.divider,
					borderRadius: 2,
					borderStyle: 'solid',
					borderWidth: 1,
					padding: theme.spacing(1, 1.5),
					...(sxBox as object),
				};
			}}>
			<Grid alignItems="center" container justifyContent="space-between" spacing={2}>
				<Grid item xs={true}>
					<InputLabel
						disabled={disabled}
						htmlFor={id}
						required={required}
						sx={{ margin: 0, userSelect: 'none' }}>
						{label}
					</InputLabel>
					{helperText && (
						<Typography color="brand.grey.500" variant="caption">
							{helperText}
						</Typography>
					)}
				</Grid>
				<Grid item xs="auto">
					<MuiCheckbox
						disabled={disabled}
						id={id}
						required={required}
						sx={{ padding: 0 }}
						{...props}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};
